export default "__VITE_ASSET__DDirRUGL__"